module.exports = __webpack_public_path__ + "img/orange_121.fc9b22c0.png";